import { defineLocale } from "../../registry";

const options = defineLocale({
  ru: {
    "options.title": "Опции",
    "options.list.title": "Опции Pick",
    "options.list.empty": "Опций пока нет",
    "options.hint":
      "Названия, порядок и состав опций сохраняются вместе с контентом. Ссылки и партнёры настраиваются на вкладке Links.",
    "options.item.title": "Опция {n}",
    "options.kind.book": "Book",
    "options.kind.enquire": "Enquire",
    "options.kind.internal": "Служебная опция",
    "options.kind.unknown": "Неизвестный вид",
    "options.internal.hint":
      "Служебная опция создаётся системой и здесь не редактируется",
    "options.link.set": "Link: set",
    "options.link.notSet": "Link: not set",
    "options.linkStatus.label": "Статус ссылки",
    "options.linkStatus.alive": "Работает",
    "options.linkStatus.dead": "Не работает",
    "options.linkStatus.unconfirmed": "Не подтверждена",
    "options.linkStatus.unknown": "Неизвестный статус",
    "options.linkStatus.none": "не проверялась",
    "options.editLink": "Править ссылку на вкладке Links",
    "options.unavailable": "Недоступна:",
    "options.unavailable.hint":
      "Пользователи не видят эту опцию как доступную. Если других доступных опций нет, в приложении будет Soon.",
    "options.move.up": "Выше",
    "options.move.down": "Ниже",
    "options.remove": "Удалить опцию",
    "options.removeLast.title": "Удалить последнюю доступную опцию?",
    "options.removeLast.body":
      "Без доступной опции Pick остаётся в выдаче, но вместо кнопки Book или Enquire в приложении будет неактивная кнопка Soon.",
    "options.removeLast.keep": "Оставить опцию",
    "options.removeLast.confirm": "Всё равно удалить",
    "options.add": "Добавить опцию",
    "options.field.kind": "Вид",
    "options.field.title": "Название",
    "options.field.subtitle": "Подзаголовок",
    "options.field.primary": "Основная опция",
    "options.new.hint":
      "Новая опция появится после сохранения. Ссылку и партнёра можно задать на вкладке Links.",
    "options.error.summary": "Исправьте отмеченные поля опций",
    "options.error.titleRequired": "Укажите название",
    "options.error.titleTooLong": "Не больше 120 символов",
    "options.error.subtitleTooLong": "Не больше 160 символов",
  },
  en: {
    "options.title": "Options",
    "options.list.title": "Pick options",
    "options.list.empty": "No options yet",
    "options.hint":
      "Option titles, order and set are saved together with the content. Links and partners are set on the Links tab.",
    "options.item.title": "Option {n}",
    "options.kind.book": "Book",
    "options.kind.enquire": "Enquire",
    "options.kind.internal": "Service option",
    "options.kind.unknown": "Unrecognised kind",
    "options.internal.hint":
      "A service option is created by the system and is not edited here",
    "options.link.set": "Link: set",
    "options.link.notSet": "Link: not set",
    "options.linkStatus.label": "Link status",
    "options.linkStatus.alive": "Alive",
    "options.linkStatus.dead": "Dead",
    "options.linkStatus.unconfirmed": "Not confirmed",
    "options.linkStatus.unknown": "Unrecognised status",
    "options.linkStatus.none": "not checked",
    "options.editLink": "Edit link on the Links tab",
    "options.unavailable": "Unavailable:",
    "options.unavailable.hint":
      "Users do not see this option as available. If no other option is available, the app shows Soon.",
    "options.move.up": "Move up",
    "options.move.down": "Move down",
    "options.remove": "Remove option",
    "options.removeLast.title": "Remove the last available option?",
    "options.removeLast.body":
      "Without an available option the pick stays listed, but the app shows a disabled Soon button instead of Book or Enquire.",
    "options.removeLast.keep": "Keep option",
    "options.removeLast.confirm": "Remove anyway",
    "options.add": "Add option",
    "options.field.kind": "Kind",
    "options.field.title": "Title",
    "options.field.subtitle": "Subtitle",
    "options.field.primary": "Primary option",
    "options.new.hint":
      "A new option appears after saving. Set its link and partner on the Links tab.",
    "options.error.summary": "Fix the marked option fields",
    "options.error.titleRequired": "Enter a title",
    "options.error.titleTooLong": "At most 120 characters",
    "options.error.subtitleTooLong": "At most 160 characters",
  },
});

export default options;
